import React from 'react';
import { Navigate, Route, Routes } from 'react-router-dom';

import RecruiterLayout from './RecruiterLayout';
import SearchPage from './pages/SearchPage';
import CandidateProfile from './pages/CandidateProfile';
import RecruiterLogin from './pages/RecruiterLogin';
import RecruiterSignup from './pages/RecruiterSignup';

/**
 * Recruiter portal route tree (mounted at /recruiter/*).
 * Separate visual system from the main HR dashboard.
 */
export default function RecruiterApp() {
  return (
    <Routes>
      <Route path="login" element={<RecruiterLogin />} />
      <Route path="signup" element={<RecruiterSignup />} />

      <Route element={<RecruiterLayout />}>
        <Route path="search" element={<SearchPage />} />
        <Route path="candidate/:id" element={<CandidateProfile />} />
      </Route>

      <Route index element={<Navigate to="search" replace />} />
      <Route path="*" element={<Navigate to="search" replace />} />
    </Routes>
  );
}
